import { SCHEDULE_TYPES } from '@src/constants/commons';
import { translateString } from '@src/util/intl/translateString';

export const FILTER_DATA_OPTIONS = [
  {
    label: translateString('general.all'),
    value: null,
  },
  {
    label: translateString('schedules.type.task'),
    value: SCHEDULE_TYPES.task,
  },
  {
    label: translateString('schedules.type.schedule'),
    value: SCHEDULE_TYPES.schedule,
  },
  {
    label: translateString('schedules.type.checkpoint_route'),
    value: SCHEDULE_TYPES.checkpoint_route,
  },
];

export const DISABLE_TYPE_KEYS = {
  [null]: 'null',
  [SCHEDULE_TYPES.task]: 'tasks',
  [SCHEDULE_TYPES.schedule]: 'schedules',
  [SCHEDULE_TYPES.checkpoint_route]: 'checkpoint_route',
};
